import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';
import Button from "components/button";

const READY_DATA = DATA.ready;

const Ready = () => {
    
    return (
        <section id='ready-id' className="ready-block container">
            <p className="title">{READY_DATA.title[0]} <span className="underline">{READY_DATA.title[1]}</span> {READY_DATA.title[2]}</p>
            <Button href={DATA['form']} className="button" content={READY_DATA.cta} />
        </section>
    )
}

export default Ready